import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useGlobalKeyboardShortcuts = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleGlobalShortcut = (e) => {
      // Don't trigger shortcuts when typing in input fields
      const isInputActive = ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName);
      
      // Navigation shortcuts (work even in input fields)
      const isNavShortcut = !e.ctrlKey && !e.altKey && ['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7'].includes(e.key);
      
      // Allow F8, F9, F10 only when NOT in input (for form actions)
      const isFormAction = ['F8', 'F9', 'F10'].includes(e.key);
      
      if (isInputActive && !isNavShortcut && isFormAction) {
        // Let form handle F8, F9, F10 when in input
        return;
      }

      // F1: Sales B2B Entry
      if (e.key === 'F1' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/sales-b2b');
      }
      
      // Alt+F1: Sales B2B History
      else if (e.key === 'F1' && e.altKey) {
        e.preventDefault();
        navigate('/sales-history-b2b');
      }
      
      // F2: Sales B2C Entry
      else if (e.key === 'F2' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/sales-b2c');
      }
      
      // Alt+F2: Sales B2C History
      else if (e.key === 'F2' && e.altKey) {
        e.preventDefault();
        navigate('/sales-history-b2c');
      }
      
      // F3: Purchase Entry
      else if (e.key === 'F3' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/purchase');
      }
      
      // Alt+F3: Purchase History (Supplier)
      else if (e.key === 'F3' && e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/purchase-history');
      }
      
      // Ctrl+F3: Purchase History (Warehouse)
      else if (e.key === 'F3' && e.ctrlKey) {
        e.preventDefault();
        navigate('/purchase-history-b2b');
      }
      
      // F4: Purchase Order
      else if (e.key === 'F4' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/purchase-order');
      }
      
      // Alt+F4: Purchase Order History
      else if (e.key === 'F4' && e.altKey) {
        e.preventDefault();
        navigate('/purchase-order-history');
      }
      
      // F5: Supplier Payment
      else if (e.key === 'F5' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/supplier-payment');
      }
      
      // F6: Customer Receipt
      else if (e.key === 'F6' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/customer-receipt');
      }
      
      // F7: Order Fulfillment
      else if (e.key === 'F7' && !e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/order-fulfillment');
      }
      
      // F8: Edit (context-dependent - handled by individual pages)
      // F9: Delete (context-dependent - handled by individual pages)
      // F10: Save (context-dependent - handled by individual pages)
      
      // Ctrl+I: Item Master
      else if (e.key === 'i' && e.ctrlKey && !e.altKey && !e.shiftKey) {
        e.preventDefault();
        navigate('/items');
      }
      
      // Ctrl+T: Stock Transfer
      else if (e.key === 't' && e.ctrlKey && !e.altKey && !e.shiftKey) {
        e.preventDefault();
        navigate('/stock-transfer');
      }
      
      // Ctrl+Shift+T: Stock Transfer History
      else if (e.key === 'T' && e.ctrlKey && e.shiftKey) {
        e.preventDefault();
        navigate('/stock-transfer-history');
      }
      
      // Ctrl+R: Stock Receive
      else if (e.key === 'r' && e.ctrlKey && !e.altKey && !e.shiftKey) {
        e.preventDefault();
        navigate('/stock-receive');
      }
      
      // Ctrl+A: Stock Audit (override default Select All)
      else if (e.key === 'a' && e.ctrlKey && !e.altKey && !e.shiftKey && !isInputActive) {
        e.preventDefault();
        navigate('/stock-audit');
      }
      
      // Ctrl+C: Shift Management (override default Copy)
      else if (e.key === 'c' && e.ctrlKey && !e.altKey && !e.shiftKey && !isInputActive) {
        e.preventDefault();
        navigate('/shift-management');
      }
      
      // Ctrl+S: Sales Order (override default Save)
      else if (e.key === 's' && e.ctrlKey && !e.altKey && !e.shiftKey && !isInputActive) {
        e.preventDefault();
        navigate('/sales-order');
      }
      
      // Alt+S: Sales Order History
      else if (e.key === 's' && e.altKey && !e.ctrlKey) {
        e.preventDefault();
        navigate('/sales-order-history');
      }
    };

    window.addEventListener('keydown', handleGlobalShortcut);
    return () => window.removeEventListener('keydown', handleGlobalShortcut);
  }, [navigate, location]);

  return null;
};

export default useGlobalKeyboardShortcuts;
